import {Routes, Route} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {DetailPage} from './pages/DetailPage';
import {rbacActions} from '../../config/rbac/actions.ts';
import {RestrictedRouteElement} from '../../components/RestrictedRouteElement.tsx';

// Every sub-route of /provider-mappings/* lives here (§5a), each gated at the route.
export const ProviderMappingsLayout = () => {
    return (
        <Routes>
            <Route
                index
                element={<RestrictedRouteElement rbacAction={rbacActions.ListProviderMappings}>
                    <IndexPage/>
                </RestrictedRouteElement>}
            />
            <Route
                path=':id'
                element={<RestrictedRouteElement rbacAction={rbacActions.GetProviderMapping}>
                    <DetailPage/>
                </RestrictedRouteElement>}
            />
        </Routes>
    );
};
